// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-tab-description {
  display: block;
  margin: var(--wm-feature-details-margin);
}
wm-tab-description .webmapp-pageroute-tabdescription-description {
  --wm-description-line-height: 0.875rem;
  padding-top: 10px;
  margin-bottom: 10px;
  color: var(--wm-feature-details-description-color);
  overflow: hidden;
  transition: max-height 0.4s ease-in-out;
  max-height: calc(var(--wm-max-description-lines) * var(--wm-description-line-height));
  display: -webkit-box;
  -webkit-line-clamp: var(--wm-max-description-lines);
  -webkit-box-orient: vertical;
}
wm-tab-description .webmapp-pageroute-tabdescription-description.expanded {
  max-height: 5000px !important;
  -webkit-line-clamp: unset;
}
wm-tab-description .webmapp-pageroute-tabdescription-title {
  font-weight: var(--wm-feature-details-title-font-weight);
  font-size: var(--wm-feature-details-title-font-size);
  color: var(--wm-feature-details-title-color);
  font-family: var(--wm-feature-details-title-font-family);
}
wm-tab-description .webmapp-pageroute-tabdescription-photoslider {
  padding: 20px 0;
  overflow: visible;
}
wm-tab-description .webmapp-pageroute-tabdescription-photoslider .webmapp-pageroute-tabdescription-photo {
  height: 150px;
  width: 250px;
}
wm-tab-description .webmapp-pageroute-tabdescription-photoslider .webmapp-pageroute-tabdescription-photo::part(image) {
  border-radius: 15px;
}
wm-tab-description .wm-expand-button {
  color: var(--ion-text-color);
  cursor: pointer;
  text-decoration: underline;
  margin-top: 8px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/tab-description/tab-description.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,wCAAA;AACF;AACE;EAEE,sCAAA;EAGA,iBAAA;EACA,mBAAA;EACA,kDAAA;EACA,gBAAA;EACA,uCAAA;EACA,qFAAA;EACA,oBAAA;EACA,mDAAA;EACA,4BAAA;AAFJ;AAII;EACE,6BAAA;EACA,yBAAA;AAFN;AAME;EACE,wDAAA;EACA,oDAAA;EACA,4CAAA;EACA,wDAAA;AAJJ;AAOE;EACE,eAAA;EACA,iBAAA;AALJ;AAOI;EACE,aAAA;EACA,YAAA;AALN;AAMM;EACE,mBAAA;AAJR;AASE;EACE,4BAAA;EACA,eAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;AAPJ","sourcesContent":["wm-tab-description{\n  display: block;\n  margin: var(--wm-feature-details-margin);\n\n  .webmapp-pageroute-tabdescription-description {\n    // default line-height (0.875rem) sovrascrivibile via variabile CSS\n    --wm-description-line-height: 0.875rem;\n    // padding: 10px;\n    // padding-bottom: 0;\n    padding-top: 10px;\n    margin-bottom: 10px;\n    color: var(--wm-feature-details-description-color);\n    overflow: hidden;\n    transition: max-height .4s ease-in-out;\n    max-height: calc(var(--wm-max-description-lines) * var(--wm-description-line-height));\n    display: -webkit-box;\n    -webkit-line-clamp: var(--wm-max-description-lines);\n    -webkit-box-orient: vertical;\n\n    &.expanded {\n      max-height: 5000px !important;\n      -webkit-line-clamp: unset;\n    }\n  }\n\n  .webmapp-pageroute-tabdescription-title {\n    font-weight: var(--wm-feature-details-title-font-weight);\n    font-size: var(--wm-feature-details-title-font-size);\n    color: var(--wm-feature-details-title-color);\n    font-family: var(--wm-feature-details-title-font-family);\n  }\n\n  .webmapp-pageroute-tabdescription-photoslider {\n    padding: 20px 0;\n    overflow: visible;\n\n    .webmapp-pageroute-tabdescription-photo {\n      height: 150px;\n      width: 250px;\n      &::part(image) {\n        border-radius: 15px;\n      }\n    }\n  }\n\n  .wm-expand-button {\n    color: var(--ion-text-color);\n    cursor: pointer;\n    text-decoration: underline;\n    margin-top: 8px;\n    font-weight: bold;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
